import { AxiosResponse } from "axios";
import { api } from "../api";
import {
  GetTrashParams,
  RestoreResponse,
  TrashEntity,
  TrashListResponse,
} from "./trash.types";

export const getTrash = async (
  entity: TrashEntity,
  params: GetTrashParams
): Promise<TrashListResponse> => {
  try {
    const response: AxiosResponse<TrashListResponse> = await api.get(
      "/admin/content/trash",
      { params: { entity, ...params } }
    );

    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch trash:", error);
    throw error;
  }
};

export const restoreEntity = async (
  entity: TrashEntity,
  id: number
): Promise<RestoreResponse> => {
  try {
    const response: AxiosResponse<RestoreResponse> = await api.post(
      `/admin/content/trash/${entity}/${id}/restore`
    );

    return response.data;
  } catch (error: any) {
    console.error("Failed to restore trash entity:", error);
    throw error;
  }
};
